import {Map} from 'immutable';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as MatchResultActions from 'actions/MatchResults';

export default function (scores, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
            return Map();

        case LIVE_INIT.SUCCESS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
            return init(Map(), action.data);

        case LIVE_UPDATE.SUCCESS:
            return update(scores, action.data);
    }

    return scores;
}
function init(scores, data) {
    if (data.scores !== undefined) {
        scores = addScores(scores, data.scores.add);
    }

    return scores;
}

function update(scores, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        //scores = removeEntities(scores, 'sportId', data.sports.remove);
        scores = myRemoveEntitiesBySport(scores, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        //scores = removeEntities(scores, 'leagueId', data.leagues.remove);
        scores = myRemoveEntities(scores, 'leagueId', data.leagues.remove);
    }

    if (data.events != undefined && data.events.remove !== undefined) {
        //scores = removeEntities(scores, 'matchId', data.events.remove);
        scores = myRemoveEntities(scores, 'matchId', data.events.remove);
    }

    if (data.scores !== undefined) {
        //scores = removeEntities(scores, 'id', data.scores.remove);
        scores = myRemoveEntities(scores, 'id', data.scores.remove);
        scores = addScores(scores, data.scores.add);
        scores = changeScores(scores, data.scores.change);
    }

    return scores;
}

function addScores(scores, addScores) {
    if (addScores === undefined) {
        return scores;
    }

    return scores.withMutations(s => {
        for (let i = 0; i < addScores.length; i++) {
            let score = Map(addScores[i]);

            s.set(score.get('id'), score);
        }
    });
}

function changeScores(scores, changeScores) {
    if (changeScores === undefined) {
        return scores;
    }

    return scores.withMutations(s => {
        for (let i = 0; i < changeScores.length; i++) {
            let score = Map(changeScores[i]);

            s.set(score.get('id'), score);
        }
    });
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/scoresReducer.js